import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { CARD_STYLE_CONSTRUCTOR, CARD_STYLE_DARK, CARD_STYLE_YANDEX } from "../../constants/tariffTile";
import { Cut, Default, Half, Max, Wide } from "./components/CardTypes";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
var cardTypeComponents = {
  cut: Cut,
  default: Default,
  half: Half,
  wide: Wide,
  max: Max
};
var TariffTile = /*#__PURE__*/memo(function (props) {
  var isDark = useMemo(function () {
    return props.cardStyle === CARD_STYLE_DARK;
  }, [props.cardStyle]);
  var isYandex = useMemo(function () {
    return props.cardStyle === CARD_STYLE_YANDEX;
  }, [props.cardStyle]);
  var isConstructor = useMemo(function () {
    return props.cardStyle === CARD_STYLE_CONSTRUCTOR;
  }, [props.cardStyle]);
  var cardType = useMemo(function () {
    return props.cardType || 'default';
  }, [props.cardType]);
  var Component = cardTypeComponents[cardType];
  return /*#__PURE__*/React.createElement("a", {
    className: cn('link'),
    href: props === null || props === void 0 ? void 0 : props.link,
    onClick: props.onLinkClick,
    "data-t-id": "components-TariffTile"
  }, /*#__PURE__*/React.createElement(Component, _extends({
    isConstructor: isConstructor,
    isDark: isDark,
    isYandex: isYandex
  }, props, {
    cardType: cardType
  })));
});
export { TariffTile };